import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { GetDataDTO } from "../../schema/Common/GetDataDTO";
import { AchievementDetailDTO } from "../../schema/Gamification/AchievementDetail/AchievementDetailDTO";
import { AchievementDetailFiltersDTO } from "../../schema/Gamification/AchievementDetail/AchievementDetailFiltersDTO";

@Injectable({
    providedIn: "root"
})
export class ApiAchievementDetailsService {
    private relativePath: string;

    constructor(private httpClient: HttpClient) {
        this.relativePath = `${environment.gamification.url}/api/v1/AchievementDetails`;
    }

    list(filter: AchievementDetailFiltersDTO): Observable<GetDataDTO<AchievementDetailDTO>> {
        let params = new HttpParams()
            .set("skip", filter.skip.toString())
            .set("take", filter.take.toString())
            .set("sortOrder", filter.sortOrder.toString())
            .set("orderBy", filter.orderBy.toString());

        if (filter.find != null) params = params.set("find", filter.find);
        if (filter.rankingId != null) params = params.set("rankingId", filter.rankingId);
        if (filter.achievementId != null) params = params.set("achievementId", filter.achievementId);
        if (filter.startsAt != null) params = params.set("startsAt", filter.startsAt);
        if (filter.endsAt != null) params = params.set("endsAt", filter.endsAt);
        if (filter.settingsType != null) params = params.set("settingsType", filter.settingsType);

        if (filter.userIds?.length > 0) filter.userIds.forEach((id) => (params = params.append("userIds", id)));
        if (filter.courseIds?.length > 0) filter.courseIds.forEach((id) => (params = params.append("courseId", id)));

        return this.httpClient.get<GetDataDTO<AchievementDetailDTO>>(`${this.relativePath}`, { params: params });
    }

    Get(id: string): Observable<AchievementDetailDTO> {
        return this.httpClient.get<AchievementDetailDTO>(`${this.relativePath}/${id}`);
    }
}
